import React, { Component } from 'react'
import DefaultLayout from "../layout/Default";

class Remove extends Component {
    constructor(props) {
        super(props)

        this.state = {

        }
    }

    render() {
        return (
            <DefaultLayout>
                <div className="container has-text-left mt">
             <h2 className="has-text-centered">Removal of a tattoo takes time, affords patience, and obviously costs money. Tattoodo’s informational guide this time introduces you to laser removal which is the most efficient way to get rid of your tattoo.</h2>

        <b>Summary</b> 
       
        <div className="content">
<ul>
    <li>      The best method for tattoo removal is laser removal. There are other options but they are less common and more painful.
</li>
    <li>Laser removal breaks apart pigment particles so that your immune system’s cells can break them down.
</li>
    <li>Laser tattoo removal can cost between US$200–$500 per treatment session depending on where you choose to go.
</li>
    <li>Depending on the size, pigments, and age of your tattoo, laser can take up to 18 months. This is only an estimate. A laser technician can let you know through consultation.
</li>
    <li>The average time between laser treatments is 4-6 weeks due to healing.
</li>
<li>Yes, laser tattoo removal does hurt, but so does having a tattoo that you hate.
</li>
     </ul>
     </div>
     


   <h3 className="title mt">What are my options to have a tattoo removed?</h3>
   It is not easy to get a tattoo removed. However, if you decide you no longer want your tattoo, you can opt for laser removal which is the best method available.

 
<div className="content">
Some alternatives to laser removal include:

<ul>
    <li>Dermabrasion
</li>
    <li>Chemical peels
</li>
    <li>Excision
</li>
    <li>Cryosurgery
</li>
    </ul>
    </div>

<br/>
These methods for tattoo removal are much less common and can also be quite painful.

<div className="has-text-centered mt">
    <img src="https://tattoodo-mobile-app.imgix.net/images/posts/20180719_iyanoQ4yhK07l7v.jpg?auto=format%2Ccompress&fit=crop&w=500" alt=""/>
</div>

<h4 className="title mt">How does laser tattoo removal work?</h4>
<br/>
A physician or laser specialist will pass laser energy through your outer skin to target the tattoo ink beneath the epidermis. The strong effect of laser energy will fragment the ink into smaller components, allowing the ink to be absorbed by the body naturally and broken down like any other outside substance or chemical. Your tattoo looks like art, but through the lens of science, it is nothing more than a big cluster of pigmented skin cells called chromophores, embedded forever in your body’s protective layer. When the laser breaking up the chromophores on the very outer surface of your skin, the scavenger cells in the deeper dermis layer under your skin will remove the chromophores from your body through the natural toxin removal process, the same way your body treats any other foreign invader.

<div className="has-text-centered mt">
    <img src="https://tattoodo-web.imgix.net/guides/content/laser-removal/tattoo-removal.jpg?auto=format%2Ccompress&fit=crop&w=500" alt=""/>
<footer>Laser treatment breaks apart ink particles so they are easier for your immune system’s cells to break down.
</footer>
</div>
<h4 className="has-text-centered"></h4>What will laser removal cost?
<br/>
Laser tattoo removal can cost between US$200–$500 per treatment session depending on where you choose to go. Be sure to do your research in advance by reading previous clients’ reviews and investigate the work of other costumers. You should consult your physician or dermatologist before you make any final decisions, and they may be able to refer you to a reputable and recommended removal specialist.


<h4 className="title mt">How long will it take to remove my tattoo?</h4>
The permanency of your tattoo will mean that it can take up to 18 months to complete the treatment sessions for your tattoo removal. But this is only an estimate. Unfortunately, the number of sessions that will be required cannot be approximated during your initial consultation or when you begin your treatment. Most technicians will tell you that your removal will require six to ten treatments. It is possible for a successful removal to take six to ten sessions, but this number could realistically be much, much higher.

<h4 className="title mt">What are the possible side effects of laser tattoo removal?</h4>
You should also note the time in between treatments. You cannot simply have one treatment after another. Applying a laser treatment again too soon after the last one will increase the risk of gruesome health consequences like skin irritation, blistering, and open wounds prone to infection. The average time between sessions is four to six weeks, but, as always, everyone’s body is different. Usually, experts recommend about eight weeks as a minimum waiting time in between treatment sessions. If patients experience any side effects that could put their skin in danger, the waiting time is usually increased.

<h4 className="title mt">Does treatment for different tattoos vary?</h4>
Some tattoos take longer to treat than others. Here are a few reasons:
<div className="content">

<ul>
    <li>Everybody has a unique immune system that responds to the laser treatment and tattoo removal differently.
</li>
    <li>The location of your tattoo will affect how long the treatment process takes. Color fading takes much longer for tattoos on the lower extremities, since the furthest points on your arms and legs are far away from your heart. The closer your tattoo is to your heart, the better the circulation in the skin, leading to better healing results. By contrast, areas with poor circulation heal very poorly throughout the tattoo removal process. For example, the ankle is a particular difficult body part to treat.
</li>
    <li>Different skin tones and the different types of inks and colors used will also have an effect on the duration of the removal process.
</li>
    <li>Finally, the depth of the tattoo will factor in to how long it takes for laser treatment to remove your tattoo. This means that professional tattoos can be more difficult to remove than amateur tattoos since the ink penetrates the skin more deeply and more uniformly.
</li>
</ul>
</div>

<h4 className="title mt">Does laser tattoo removal hurt?</h4>
<br/>
Yes, it probably will. Only two lasers are capable of tattoo removal, the Q-Switch Yag or the Picosecond laser. Both of these pieces of technology will inflict trauma at the location of your tattoo. Educate yourself on both types of lasers before you make your final decision about the treatment. These are somewhat invasive pieces of technology that may have side effects on your skin, so it is important to do all the research you can.

Your body will instinctively respond to any trauma by sending an army of White Blood Cells to the site of the invasion. White Blood Cells are the soldiers of your body’s immune system. White Blood Cells perform a biological process called phagocytosis, which basically means they are gobbling up smaller food pieces, in this case the ink particles.

You may experience swelling, redness, and bleeding that can be very painful even in between sessions.


                </div>
            </DefaultLayout>
        )
    }
}

export default Remove
